<template>
  <div class="user_container">
    <div class="container_con">
      <div class="title">{{startDate}}到{{endDate}}周报</div>
      <div class="content">
        <div class="field field_width">
          <div class="field_label">司机姓名：</div>
          <div class="field_value">{{ baseinfo.driverName }}</div>
        </div>
        <div class="field">
          <div class="field_label">好&nbsp;评&nbsp;率：</div>
          <div class="field_value">{{ baseinfo.weekGoodCommentRadio }}%</div>
        </div>
        <div class="field">
          <div class="field_label">本周接单：</div>
          <div class="field_value">{{ baseinfo.weekOrderNum }}单</div>
        </div>
        <div class="field">
          <div class="field_label">环比上周：</div>
          <div class="field_value" v-if="baseinfo.weekGoodCommentRadioChainRadio > 0">
            {{ "+" + baseinfo.weekGoodCommentRadioChainRadio + "%" }}
          </div>
          <div class="field_value" v-else-if="baseinfo.weekGoodCommentRadioChainRadio < 0">
            {{ "-" + baseinfo.weekGoodCommentRadioChainRadio + "%" }}
          </div>
          <div class="field_value" v-else>
            {{ baseinfo.weekGoodCommentRadioChainRadio + "%"  }} 
          </div>
        </div>
        <div class="field">
          <div class="field_label">评价反馈：</div>
          <div class="field_value">{{baseinfo.weekToolCommentNum}}条</div>
        </div>
        <div class="field">
          <div class="field_label">综合评分：</div>
          <div class="field_value">{{baseinfo.weekAverageScore}}分</div>
        </div>
        <div class="field">
          <div class="field_label">四星以上：</div>
          <div class="field_value">{{baseinfo.weekGoodCommentNum}}条 </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from "@/apis";

// import { getToken, setToken } from "@/utils/cookie";
import apiCar from "@/apis/car";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      driverCode: "",
      startDate: "",
      endDate: "",
      baseinfo: {},
    };
  },
  created() {},
  mounted() {
    const { driverCode, startDate, endDate } = this.$route.query;
    this.driverCode = driverCode;
    this.startDate = startDate;
    this.endDate = endDate;
    this.getList();
    // let token = getToken();
    // if (token) {
    //   this.getUserToken(token);
    // } else {
    //   this.$bus.$on("processToken", (res) => {
    //     this.getUserToken(res);
    //   });
    // }
  },
  methods: {
    //获取司机评价详情
    getList() {
      apiCar
        .weekCommentCountByDriver({
          driverCode: this.driverCode,
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then((data) => {
          console.log(data, "data");
          const res = data.data;
          this.baseinfo = res;
        });
    },
    // getUserToken(empNo) {
    //   if (empNo) {
    //     let thisname = empNo;
    //     api.queryByUsername({ username: thisname }).then((data) => {
    //       const info = data.data;
    //       console.log(info, "info");

    //       // this.$store.commit("changeUserInfo", info);
    //       setToken(empNo);
    //     });
    //   }
    // },
    //返回上一页
    toUrl() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  padding: 30px;
  margin: auto;
  font-size: 1vh;
  font-size: 30px;
  //   position: relative;
  overflow: hidden;
  .container_con {
    background: #fff;
    border-radius: 20px;
    padding: 30px;
    .title {
      font-size: 32px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    .content {
      display: flex;
      align-content: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .field {
        width: 50%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .field_label {
          color: rgba(102, 102, 102, 1);
        }
        .field_value {
        }
      }
      .field_width{
        width: 100%;
      }
    }
  }
}
</style>
